import React, { useState } from "react";
import api from "../api";

export default function PublicacionForm() {
  const [titulo, setTitulo] = useState("");
  const [contenido, setContenido] = useState("");
  const [fecha_destruccion, setFechaDestruccion] = useState("");
  const [imagen, setImagen] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState(null);

  // Obtener usuario y token
  const user = JSON.parse(localStorage.getItem("user"));
  const token = localStorage.getItem("token");

  // 🔥 TEMPORAL: Verificar estructura del usuario
console.log("🔍 Datos completos del usuario:", user);
console.log("🔍 id_empleado:", user?.id_empleado);
console.log("🔍 departamento_id:", user?.departamento_id);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMensaje(null);

    // Verificar usuario
    if (!user?.id) {
      setMensaje({ tipo: "error", texto: "No hay usuario logueado" });
      setLoading(false);
      return;
    }

    try {
      const formData = new FormData();
      formData.append("titulo", titulo);
      formData.append("contenido", contenido);
      formData.append("empleado_id", user.id_empleado);
      formData.append("departamento_id", user.departamento_id || 1);
      formData.append("fecha_publicacion", new Date().toISOString().split("T")[0]);
      if (imagen) formData.append("imagen", imagen);
      if (fecha_destruccion) formData.append("fecha_destruccion", fecha_destruccion);

      // Debug: revisar datos antes de enviar
      for (let [key, value] of formData.entries()) {
        console.log(key, value);
      }
      console.log("Enviando datos para crear publicación:", formData);

      const response = await api.post(`/publicaciones`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("Respuesta del servidor:", response.data);
      setMensaje({ tipo: "success", texto: "✅ Publicación creada correctamente" });
      setTitulo("");
      setContenido("");
      setImagen(null);
      setFechaDestruccion("");

    } catch (error) {
      console.error(error);

      if (error.response?.status === 422) {
        const errores = error.response.data.errors;
        const mensajes = Object.values(errores).flat().join(" | "); 
        setMensaje({ tipo: "error", texto: mensajes || "❌ Error de validación" });
      } else {
        setMensaje({ tipo: "error", texto: error.response?.data?.message || "❌ Error al crear la publicación" });
      }

    } finally {
      // 🔹 Siempre resetear loading
      setLoading(false);
    }
  };

  return (
    <div className="bg-white shadow-md rounded-lg p-6">
      <h2 className="text-lg font-bold mb-4">Crear Publicación</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          placeholder="Título"
          value={titulo}
          onChange={(e) => setTitulo(e.target.value)}
          className="w-full border rounded p-2"
          required
        />

        <textarea
          name="contenido"
          placeholder="Contenido"
          value={contenido}
          onChange={(e) => setContenido(e.target.value)}
          className="w-full border rounded p-2"
          required
        ></textarea>

        <input
          type="date"
          placeholder="Fecha de destrucción"
          value={fecha_destruccion}
          onChange={(e) => setFechaDestruccion(e.target.value)}
          className="w-full border rounded p-2"
        />

        <input
          type="file"
          accept="image/*"
          onChange={(e) => setImagen(e.target.files[0])}
        />

        <button
          type="submit"
          disabled={loading}
          className={`w-full py-2 rounded text-white font-bold ${
            loading ? "bg-gray-400" : "bg-blue-600 hover:bg-blue-700"
          }`}
        >
          {loading ? "⏳ Subiendo..." : "Crear Publicación"}
        </button>
      </form>

      {mensaje && (
        <p
          className={`mt-4 text-center font-medium ${
            mensaje.tipo === "success" ? "text-green-600" : "text-red-600"
          }`}
        >
          {mensaje.texto}
        </p>
      )}
    </div>
  );
}
